
export default [{
    type:'Free',
    price:0,
    services: [
        'JNE - REG',
        'JNE - OKE',
        'TIKI - REG',
        'TIKI - EKO',
        'SiCepat - REG',
        'JET Express - PRI',
        'JET Express - REG',
        'J&T - EZ',
        'AnterAja - Reguler',
        'Ninja Express - Standard',
        'Lion Parcel - RegPack',
        'Lion Parcel - LandPack',
        'Wahana - Normal',
        'Pos Indonesia - Kilat Khusus'
    ]
},{
    type:'Essentials',
    price:49000,
    services: [
        'Semua Layanan +',
        'JNE - YES',
        'TIKI - ONS',
        'SiCepat - BEST',
        'JET - FX',
        'JET - XPS',
        'Ninja Express - Next Day',
        'Lion Parcel - One Pack',
        'Pos Indonesia - Q9 Same Day',
        'Pos Indonesia - Next Day',
        'AnterAja - Next Day',
        'Alfatrex - Reguler (RGS)',
        'Alfatrex - Ekonomis (ECS)'
    ]
},{
    type:'Standard',
    price:79000,
    services: [
        'Semua Essentials +',
        'Gojek - Instant',
        'Grab - Instant',
        'Paxel - Small',
        'Paxel - Medium',
        'JNE - SPS',
        'JNE - Pelikan',
        'JNE - PopBox',
        'SiCepat - SDS', 
        'Pos Indonesia - Same Day',
        'Pos Indonesia - Jumbo Ekonomi',
        'Deliveree - Pickup',
        'Deliveree - Van',
        'Deliveree - Economy',
        'MrSpeedy - Instant Bike',
        'MrSpeedy - Instant Car',
        'AnterAja - Same Day',
        'Alfatrex - Same Day (SDS)',
        'Alfatrex - Next Day (NDS)'
    ]
},{
    type:'Premium',
    price:99000,
    services: [
        'Semua Standard +',
        'Gojek - Same Day',
        'Grab - Same Day',
        'Grab - Instant Car',
        'Lalamove - Motorcycle',
        'Lalamove - MPV',
        'Lalamove - VAN',
        'Lalamove - Truck175',
        'JNE - JTR',
        'JNE - JTR 150-250',
        'JNE - JTR 150',
        'JNE - JTR 250',
        'SiCepat - Cargo',
        'SiCepat - GOKIL',
        'JET - Cargo',
        'Paxel - Large',
        'Deliveree - Tronton Wing Box',
        'Deliveree - Tronton Box',
        'Deliveree - Fuso Heavy',
        'Deliveree - Fuso Light',
        'Deliveree - CDD Box',
        'Deliveree - CDD Pickup',
        'Deliveree - CDE Frozen',
        'Deliveree - CDE Flammabel',
        'Deliveree - CDE Chemical',
        'Deliveree - Engkel Box',
        'Deliveree - Engkel Pickup',
        'Deliveree - Small Box'
    ]
}]